// @ts-nocheck
/* eslint-disable */
import { takeLatest, call, put, fork, cancel } from 'redux-saga/effects';
import { router } from 'components/routes/Router';
import * as types from 'appRedux/actions/roles';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';

function* getAllRoles() {
  const token = localStorage.getItem('token');
  const data = yield call(services.fetchGetApi, `${API_URI}/roles/list`, token);

  if (data) {
    yield put({ type: types.GET_ALL_ROLES_SUCCESS, payload: data });
  }
}

function* getRoleById(action) {
  const token = localStorage.getItem('token');
  const { id } = action;
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/roles/list?role_id=${id}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_ROLE_BY_ID_SUCCESS, payload: data });
  }
}

function* addRoles(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/roles/add`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: types.ADD_NEW_ROLES_SUCCESS, payload: data });
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    successToast('Role was created successfully.');
  }
}

function* updateRoleById(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { id, payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/roles/update_roles/?id=${id}`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    router.navigate('/usermanagement/roles');
    yield put({ type: types.GET_ALL_ROLES_REQUEST });
    successToast('Role was updated successfully.');
    window.location.reload();
  }
}

function* getAllPermissions(action) {
  const token = localStorage.getItem('token');

  const { payload } = action;
  const query = getQueryParams(payload);

  let data = yield call(
    services.fetchGetApi,
    `${API_URI}/permissions?${query}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_ALL_PERMISSIONS_SUCCESS, payload: data });
  }
}

function* roleMgmtWatcher() {
  yield takeLatest(types.GET_ALL_ROLES_REQUEST, getAllRoles);

  yield takeLatest(types.GET_ROLE_BY_ID_REQUEST, getRoleById);
  yield takeLatest(types.ADD_NEW_ROLES_REQUEST, addRoles);
  yield takeLatest(types.GET_ALL_PERMISSIONS_REQUEST, getAllPermissions);
  // yield takeLatest(
  //   types.GET_PERMISSIONS_BY_ROLE_ID_REQUEST,
  //   getPermissionByRoleId
  // );

  yield takeLatest(types.UPDATE_ROLE_BY_ID_REQUEST, updateRoleById);
}

export default roleMgmtWatcher;
